export const isConsentGivenFor = (tag) => {
  return process.client && window.OnetrustActiveGroups && window.OnetrustActiveGroups.includes(tag);
}
